import React from "react";
import NavigationSearch from "Components/App/NavigationSearch";

export default function Module(props) {

    const x = props.x;

	const [display, setDisplay] = React.useState(props.display);
	const [isFavorite, setIsFavorite] = React.useState(x.wam.isFavorite(props.id));
	// Kein eigener State fuer isStartModule - x.was.startModule ist ein einzelner,
	// modul-uebergreifender Wert (immer nur EIN Startmodul aktiv), ein lokal
	// kopierter State wuerde bei anderen, bereits gemounteten Modul-Instanzen
	// veralten, sobald das Startmodul woanders geaendert wird. Stattdessen bei
	// jedem Render frisch ableiten, force-render-Tick nur um die eigene Instanz
	// sofort nach dem Setzen zu aktualisieren.
	const [, forceUpdate] = React.useState(0);
	const isStartModule = x.was.startModule === props.id;
	// Stern (Favorit) + Haus-Zahnrad (Startmodul) standen bisher als zwei
	// einzelne Icons direkt im Modul-Header - auf dem iPhone wurde das neben
	// Titel/Toolbar zu eng/unuebersichtlich. Beide Aktionen stecken daher
	// jetzt hinter einem einzigen Zahnrad-Icon in einem kleinen Dropdown-Menue
	// (gleiches Klick-ausserhalb-Muster wie MarketdataGroupSelector.js).
	const [menuOpen, setMenuOpen] = React.useState(false);
	const menuRef = React.useRef(null);

	React.useEffect(() => {
		function handleClickOutside(e) {
			if (menuRef.current && !menuRef.current.contains(e.target)) {
				setMenuOpen(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const displayTitle = (typeof props.displayTitle === 'undefined') ? '' : props.displayTitle;
	const classes = (typeof props.classes != 'undefined') ? props.classes : '';
	const isForumModule = x.wam[props.id].moduleType === 'forum';

	function toggleFavorite() {
		x.wam.toggleFavorite(props.id, setIsFavorite);
	}

	function setAsStartModule() {
		x.was.axPost('Backend/webapp.php?module=Member&task=SaveMemberStartModule', { "forumId": props.id }, (result) => {
			if (result.data.returncode === 1) {
				x.was.startModule = props.id;
				forceUpdate((n) => n + 1);
				x.wah.addHint('"' + props.title + '" wurde als Startmodul festgelegt.');
			}
			else {
				x.wah.addHint('Startmodul konnte nicht gespeichert werden!', true);
			}
		});
	}


	x.wam.init(props.id, {
		"title": props.title
	});

	x.wam[props.id].hide = hide;
	x.wam[props.id].show = show;

	function hide() {
		setDisplay('d-none');
		if (typeof props.onHide !== 'undefined') props.onHide();
	}

	function show() {
		setDisplay('d-box');
		if (typeof props.onShow !== 'undefined') props.onShow();
	}

	function closeModule() {
		x.was.removeModule(props.id);
		x.wam.activate('forum');
	}

	function makeContent() {
		let content = {};
		let close = {};
		const moduleTitleTag = <NavigationSearch x={x} variant="compact" triggerLabel={props.title} />;

		const moduleMenuTag =
			<span className="module-menu" ref={menuRef}>
				<span
					className="bi bi-gear module-menu-icon"
					title="Modul-Optionen"
					onClick={() => setMenuOpen((current) => !current)}
				/>
				{menuOpen &&
					<div className="module-menu-dropdown">
						{!isForumModule &&
							<div className="module-menu-dropdown-item" onClick={() => { toggleFavorite(); setMenuOpen(false); }}>
								<i className={`bi ${isFavorite ? 'bi-star-fill' : 'bi-star'}`} />
								<span>{isFavorite ? 'Als Favorit entfernen' : 'Als Favorit merken'}</span>
							</div>
						}
						<div
							className={`module-menu-dropdown-item ${isStartModule ? 'module-menu-dropdown-item-disabled' : ''}`}
							onClick={isStartModule ? undefined : () => { setAsStartModule(); setMenuOpen(false); }}
						>
							<i className={`bi ${isStartModule ? 'bi-house-gear-fill' : 'bi-house-gear'}`} />
							<span>{isStartModule ? 'Ist bereits das Startmodul' : 'Als Startmodul festlegen'}</span>
						</div>
					</div>
				}
			</span>;

		if (typeof props.closeButton === 'undefined' || props.closeButton ) {
			close = <i className={`bi bi-x-square module-icon module-close`} title="Schließen" onClick={e => closeModule()} />
		}
		else {
			close = <i className={`bi bi-x-square module-icon module-icon-disabled`} title="Schließen nicht möglich: Hauptmodul"   />
		}
		content =
			<div key={"module-frame-" + props.id} id={"module-frame-" + props.id} className={` webapp-module module-frame ${classes} ${display} `}>
				<div key={'module-title-' + props.id} id={'module-title-' + props.id} className={` module-head ${displayTitle}`}>
					<span className='module-head-title '>
						<span className='module-title' >
							{moduleTitleTag}
							{moduleMenuTag}
						</span>
					</span>
					{props.toolbar}
					<span className='module-head-right'>
						{close}
						{props.titleToolbar}
					</span>
				</div>
				<div key={"module-content-" + props.id} id={"module-content-" + props.id} className={` module-content  `} >
					{props.children}
				</div>
			</div>
		return content;
	}

	return (
		<React.Fragment>
			{ makeContent() }
		</React.Fragment>
	)

};

